import React from 'react';
import { Field } from 'redux-form';

import IconRadio from 'components/Input/RadioRect';
import { PROPERTY_TYPES } from 'constants/Global';

const PropertyType = () => (
    <div className="radio-rect-list" data-step-type>
        {PROPERTY_TYPES.map((type) => (
            <Field
                name="_property_type"
                component={IconRadio}
                key={type.id}
                id={type.id}
                className="radio-rect-list__item"
                label={type.label}
                icon={type.icon}
            />
        ))}
    </div>
);

PropertyType.displayName = 'PropertyType';

/**
 * PropertyType Functional Component.
 */
export default PropertyType;
